module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-580-75a93d04b4a983b10b680ad22b5fded9.webp";